import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ spacing }) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fill, minmax(${spacing(35)}, 1fr))`,
    gap: spacing(3.5),
  },

  banner: {
    gridColumn: '1/-1',
  },
}));
